export const formatKisFee = (amount?: number | null, percent?: number | null): string => {
  const hasAmount = amount !== null && amount !== undefined;
  const hasPercent = percent !== null && percent !== undefined;

  if (!hasAmount && !hasPercent) return '--';

  const amountStr = hasAmount ? `$${amount!.toFixed(2)}` : '';
  const percentStr = hasPercent ? `${percent!.toFixed(2)}%` : '';

  if (hasAmount && hasPercent) {
    return `${amountStr} + ${percentStr}`;
  }

  return amountStr || percentStr;
};
